import httpHelper from "@/helpers/httpHelper";
// action types 
export const GET_BANK_LIST = "getBankList";
// mutation types
export const SET_BANK_LIST = "setBankList";

export default {
    state: {
        BankList: [],

    },
    getters: {
        /**
         * Get list of detailsSharing for current page
         * @param state
         * @returns {*}
         */
        loadedBankList(state) {
            return state.BankList;
        },


    },
    actions: {
        /**
         * Set the BankList 
         * @param state
         * @param payload
         */
        [GET_BANK_LIST](context, payload) {
            return new Promise((resolve, reject) => {
                httpHelper
                    .getData('sharing/banks')
                    .then((response) => {
                        let option = {};
                        let options = [];
                        response.result.forEach((element) => {
                            
                            Object.assign(option, {
                                value: element.id,
                                text: element.fa_title,
                                title: element.title
                            });
                            options.push(option);
                            option = {};
                        });
                        context.commit(SET_BANK_LIST, options);
                        resolve(options);
                    })
                    .catch((error) => {
                        reject(error)
                    })
                    .finally(() => { });
            });
        },
    },
    mutations: {

        [SET_BANK_LIST](state, payload) {
            state.BankList = payload;
        },

    }
};